import React from 'react';
import { Mail, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: 'var(--color-gray-900)',
      color: 'var(--color-white)',
      paddingTop: 'var(--spacing-2xl)',
      paddingBottom: 'var(--spacing-xl)'
    }}>
      <div className="container-artworld">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--spacing-xl)',
          marginBottom: 'var(--spacing-xl)'
        }}>
          {/* Brand Section */}
          <div>
            <h3 className="artist-name" style={{ color: 'var(--color-white)', marginBottom: 'var(--spacing-md)' }}>
              Saloni Sharma
            </h3>
            <p className="body-text" style={{ color: 'var(--color-gray-400)', fontSize: '0.95rem', lineHeight: '1.7' }}>
              <strong style={{ color: 'var(--color-white)', display: 'block', marginBottom: 'var(--spacing-sm)' }}>Land Acknowledgement</strong>
              I acknowledge that I live and work in Calgary (Moh-kins-tsis), on the traditional territories of the Treaty 7 Nations, including the Siksika Nation, Kainai Nation, Piikani Nation, Tsuut'ina Nation, and the Stoney Nakoda Nations, as well as the Métis Nation of Alberta, Region 3, and honour the Indigenous peoples who have cared for this land since time immemorial.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '1rem',
              fontWeight: '600',
              marginBottom: 'var(--spacing-md)',
              color: 'var(--color-white)'
            }}>
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Home', 'About Me', 'Gallery', 'Contact'].map((item) => (
                <li key={item} style={{ marginBottom: 'var(--spacing-xs)' }}>
                  <a
                    href={`/${item.toLowerCase().replace(' ', '-')}`}
                    className="caption-text"
                    style={{
                      color: 'var(--color-gray-400)',
                      textDecoration: 'none',
                      transition: 'color var(--transition-base)'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--color-white)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-400)'}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '1rem',
              fontWeight: '600',
              marginBottom: 'var(--spacing-md)',
              color: 'var(--color-white)'
            }}>
              Connect
            </h4>
            <div style={{ display: 'flex', gap: 'var(--spacing-md)' }}>
              <a
                href="mailto:saloni@artwithsaloni.com"
                style={{
                  color: 'var(--color-gray-400)',
                  transition: 'color var(--transition-base)'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--color-white)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-400)'}
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/saloni-sharma-941b39192/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'var(--color-gray-400)',
                  transition: 'color var(--transition-base)'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--color-white)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-400)'}
                aria-label="LinkedIn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/salonisharma2426"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'var(--color-gray-400)',
                  transition: 'color var(--transition-base)'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--color-white)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-400)'}
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/CreativeArtsWithSaloni/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'var(--color-gray-400)',
                  transition: 'color var(--transition-base)'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--color-white)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-400)'}
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid var(--color-gray-800)',
          paddingTop: 'var(--spacing-lg)',
          textAlign: 'center'
        }}>
          <p className="caption-text" style={{ color: 'var(--color-gray-500)', margin: 0 }}>
            © {new Date().getFullYear()} <a href="https://raniac.in/" target="_blank" rel="noopener noreferrer">Raniac. All rights reserved.</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
